import { refreshLoginApi } from "@/api/auth";
import { api } from "@/api/index";
import router from "@/router";
import store from "@/store";

let isRefreshing = false;
let failedQueue = []; // Массив в который попадают promise from catch
/**
 * складывает запросы, которые не удалось выполнить, в очередь (записывает их в массив)
 * @param error - объект ошибки
 * @param token - токен аутентификации
 */
const processQueue = (error, token = null) => {
    console.log(failedQueue);
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

/**
 * перехватывает любую сетевую ошибку, в случае протухшего токена инициализирует вызов пере аутентификации
 * @param error - принимает объект с ошибкой
 * @returns {Promise<unknown>}
 */
export const interceptorsError = async (error) => {
    const originalRequest = error.config;

    const isUrlRefreshToken = /auth\/refresh/.test(originalRequest?.url ?? "");

    if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        !isUrlRefreshToken
    ) {
        if (isRefreshing) {
            return new Promise(function (resolve, reject) {
                // создает промис для неудавшихся задач

                failedQueue.push({ resolve, reject });
            })
                .then((token) => {
                    console.log(token);
                    originalRequest.headers["Authorization"] =
                        "Bearer " + token;
                    return api(originalRequest);
                })
                .catch((err) => {
                    throw err;
                });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise((resolve, reject) => {
            refreshLoginApi()
                .then((jwt) => {
                    store.commit("user/SET_JWT", jwt);
                    api.defaults.headers.common["Authorization"] =
                        "Bearer " + jwt.jwt_token;
                    originalRequest.headers["Authorization"] =
                        "Bearer " + jwt.jwt_token;
                    processQueue(null, jwt.jwt_token);
                    resolve(api(originalRequest));
                })
                .catch((err) => {
                    processQueue(err, null);
                    router.push("/login");
                    reject(err);
                })
                .then(() => {
                    isRefreshing = false;
                });
        });
    } else {
        console.log("error - ", error);
        return Promise.reject(error);
    }
};
